import React from "react";
import "./CategoryCard.css";

const ProductCategoryCard = ({ category, onClick, priority = false }) => {
  const handleCardClick = () => {
    // Save scroll position before navigation
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    sessionStorage.setItem("categoryListScroll", scrollY.toString());

    // Set category ID in session storage
    sessionStorage.setItem("CategoryID", category.ProductCategoryID);

    // Mark that this navigation is from a category click
    sessionStorage.setItem("isFromCategoryClick", "true");

    // Call the onClick handler from parent
    if (onClick) {
      onClick(category);
    } else {
      // Fallback navigation if onClick not provided
      window.location.href = `/shop/${category.CategoryName}/${category.ProductCategoryID}`;
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleCardClick();
    }
  };

  return (
    <div
      className="category-tile"
      role="button"
      tabIndex={0}
      onClick={handleCardClick}
      onKeyDown={handleKeyDown}
      style={{ contentVisibility: "auto", containIntrinsicSize: "0 300px" }}
    >
      <div className="category-tile__image-wrap">
        <img
          className="category-tile__image"
          alt={category.CategoryName}
          src={category.CategoryImage}
          loading={priority ? "eager" : "lazy"}
          fetchPriority={priority ? "high" : "auto"}
          decoding="async"
        />
        <div className="category-tile__overlay">
          <span className="category-tile__name">{category.CategoryName}</span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ProductCategoryCard);
